import React, { useRef, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { FormDialog } from 'components/dialogs/formDialog';
import { CheckboxWrapper } from 'components/formInputs/wrappers/checkboxWrapper';

export const OrderSettingsEditForm = ({ itemData, isOpen, closeModal, onSave }) => {
  const schema = yup.object().shape({
    separate_in_progress: yup.boolean().default(itemData?.separate_in_progress || false),
    separate_delivering: yup.boolean().default(itemData?.separate_delivering || false),
    skip_ready: yup.boolean().default(itemData?.skip_ready || false),
  });

  const cancelButtonRef = useRef(null);

  const {
    register,
    reset,
    handleSubmit,
  } = useForm({
    defaultValues: schema.default(),
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    reset(itemData);
  }, [itemData, reset]);

  const onFormSubmit = async (data) => {
    const submitedData = {
      separate_in_progress: data.separate_in_progress,
      separate_delivering: data.separate_delivering,
      skip_ready: data.skip_ready,
    };

    onSave(submitedData);
  };

  const onError = (data) => console.log(data);

  return (
    <FormDialog
      isOpen={isOpen}
      cancelButtonRef={cancelButtonRef}
      onClose={closeModal}
      title="Edit order settings"
      buttons={[
        { text: 'Save', type: 'submit', color: 'blue' },
        { text: 'Cancel', onClick: closeModal, color: 'gray' },
      ]}
      onSubmit={handleSubmit(onFormSubmit, onError)}
      small
    >
      <div className="grid grid-cols-6 gap-6 text-left">
        <CheckboxWrapper
          register={register}
          name="separate_in_progress"
          title={'Show "In Progress" tab'}
          subtitle="will separate new and in progress states"
          responsiveClassName="col-span-6"
        />
        <CheckboxWrapper
          register={register}
          name="skip_ready"
          title={'Skip "Ready" status'}
          subtitle="will complete order after it's prepared"
          responsiveClassName="col-span-6"
        />
        <CheckboxWrapper
          register={register}
          name="separate_delivering"
          title={'Show "Delivering" tab'}
          subtitle="will show delivering items in another tab"
          responsiveClassName="col-span-6"
        />
      </div>
    </FormDialog>
  );
};
